import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  viewBox: "0 0 116 115",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m49.094 57.854-7.087 4.092 7.087 4.092v-8.184ZM66.357 66.038l7.088-4.092-7.088-4.092v8.184Z",
  fill: "#525052"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M57.704 115c31.756 0 57.5-25.744 57.5-57.5S89.461 0 57.704 0C25.948 0 .204 25.744.204 57.5s25.744 57.5 57.5 57.5ZM25.81 32.39V89.5h7.087V32.588h49.615V89.5h7.087V32.39l-6.89-6.89H32.7l-6.89 6.89Zm30.376 3.407H35.935V89.5h20.25V35.797Zm23.288 0h-20.25V89.5h20.25V35.797Z",
  fill: "#525052"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }